export default __webpack_public_path__ + "static/media/IMG_1581.aadb1778.PNG";